import type { formulaireClient as Fr } from '../fr/formulaireClient';

/** « formulaireClient » in English — typed on the French: a missing sentence does not compile. */
export const formulaireClient: typeof Fr = {
  modifierTitre: (nom) => `Edit ${nom}`,
  modificationImpossible: 'Unable to save the changes',
  creationImpossible: 'Unable to create the customer',
  nouveauClient: 'New customer',
  type: 'Type',
  particulier: 'Individual',
  societe: 'Company',
  raisonSociale: 'Company name',
  raisonSocialeObligatoire: 'The company name is the only required field.',
  compteATerme: 'Account customer — pays at 30 days',
  registreCommerce: 'Trade register no.',
  nif: 'Tax ID (NIF)',
  nis: 'Statistical ID (NIS)',
  articleImposition: 'Tax article no.',
  quatreLignes: 'These four lines are printed on the invoice, under “BILL TO”.',
  nom: 'Last name',
  nomObligatoire: 'The last name is the only required field.',
  prenom: 'First name',
  dateNaissance: 'Date of birth',
  dateNaissanceAide: 'Used for the minimum age check (eligibility rule).',
  dateNaissanceManquante: 'Missing — the age in the eligibility rule cannot be checked.',
  lieuNaissance: 'Place of birth',
  telephone: 'Phone',
  telephoneManquant: 'Missing — nobody to call if the vehicle is not returned.',
  email: 'Email',
  adresse: 'Address',
  typePiece: 'ID document type',
  pieceCin: 'ID card',
  piecePc: 'Driving licence',
  piecePsp: 'Passport',
  pieceCm: 'Military ID card',
  numeroPiece: 'ID document no.',
  pieceManquante: 'Missing — the rental agreement will print without an ID document.',
  delivreeLe: 'Issued on',
  delivreeA: 'Issued at',
  numeroPermis: 'Driving licence no.',
  permisDelivreLe: 'Licence issued on',
  permisAide: 'Used for the years-of-driving check (eligibility rule).',
  permisManquant: 'Missing — the licence seniority in the eligibility rule cannot be checked.',
  ficheIncomplete: 'Incomplete record — you can still save it',
  pasTelephone: 'No phone: nobody to call if the vehicle is not returned.',
  pasPiece: 'No ID document number: the rental agreement will print without an ID document.',
  niNaissanceNiPermis: 'No date of birth and no licence date',
  pasNaissance: 'No date of birth',
  pasPermis: 'No licence date',
  article01Sep: ': ',
  aucuneLocation: 'no rental can be recorded',
  article01Fin: ' for this customer while it is missing — the eligibility rule cannot be overridden on missing data.',
  completez: 'Complete the record when the customer comes in with their documents: “Customers” then “Edit”.',
  enregistrement: 'Saving…',
  enregistrerCorrections: 'Save corrections',
  creerClient: 'Create customer',
};
